import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { B100, N20, N50A, N60A } from '@atlaskit/theme/colors';
import { TableBodyRow } from '../table-row';
const rankingStyles = css({
  display: 'block'
});
const rankingItemStyles = css({
  backgroundColor: `var(--ds-surface-overlay, ${N20})`,
  borderRadius: "var(--ds-border-radius-050, 2px)",
  boxShadow: `var(--ds-shadow-overlay, ${`0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`})`
});
const draggableStyles = css({
  outlineWidth: "var(--ds-border-width, 2px)",
  '&:focus': {
    outlineColor: `var(--ds-border-focused, ${B100})`,
    outlineStyle: 'solid'
  }
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const RankableTableBodyRow = /*#__PURE__*/forwardRef(({
  isRanking,
  isRankingItem,
  testId,
  ...props
}, ref) => {
  return jsx(TableBodyRow, _extends({
    css: [isRanking && rankingStyles, isRankingItem && rankingItemStyles, draggableStyles],
    ref: ref,
    testId: testId
  }, props));
});